import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';
import Link from 'common/components/LocalizedLink/LocalizedLink';

import { injectIntl } from 'react-intl';

//styles
import styles from './ServiceBox.module.scss';

@injectIntl
export default class ServiceBox extends Component {
  static propTypes = {
    service: PropTypes.object.isRequired,
    more: PropTypes.string
  };

  render() {
    const {
      service: { name, description, image },
      more
    } = this.props;
    return (
      <div className={styles.Wrapper}>
        <div className={styles.ImageBox}>
          <img
            src={OptimizeImagesService.adjustImageSize(image)}
            alt="Service"
            className={styles.Image}
          />
        </div>
        <h3 className={styles.DescriptionTitle}>{name}</h3>
        <div
          className={styles.DescriptionParagraph}
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {more && (
          <Link to="/" className={styles.SeeMoreLink}>
            {more}
          </Link>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/OurServices/ServiceBox/ServiceBox.js